var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueClose(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.27748 2.27748C2.64745 1.90751 3.24729 1.90751 3.61726 2.27748L8 6.66022L12.3827 2.27748C12.7527 1.90751 13.3526 1.90751 13.7225 2.27748C14.0925 2.64745 14.0925 3.24729 13.7225 3.61726L9.33978 8L13.7225 12.3827C14.0925 12.7527 14.0925 13.3526 13.7225 13.7225C13.3526 14.0925 12.7527 14.0925 12.3827 13.7225L8 9.33978L3.61726 13.7225C3.24729 14.0925 2.64745 14.0925 2.27748 13.7225C1.90751 13.3526 1.90751 12.7527 2.27748 12.3827L6.66022 8L2.27748 3.61726C1.90751 3.24729 1.90751 2.64745 2.27748 2.27748Z",
    fill: "#2196F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueClose);
export default __webpack_public_path__ + "static/media/blueClose.860d39c147d46e61538ca6bfcb6dd80f.svg";
export { ForwardRef as ReactComponent };